export const E2E_TEST_PATH = "e2e-test";
